import { Controller } from 'stimulus'
import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded'

export default class extends Controller {
  connect() {
    this.msnry = new Masonry(this.element, {
      itemSelector: '[data-grid-item]',
      columnWidth: '[data-grid-sizer]',
      percentPosition: true,
    })

    imagesLoaded(this.element, () => {
      this.msnry.layout()
    })
  }

  disconnect() {
    this.msnry.destroy()
  }
}
